import React from "react";
import { Progress, Statistic, Icon, Row, Col, Card } from "antd";

function TopKeywordsOverview(props) {
  const total = props.overview["dropped"] + props.overview["increased"] + props.overview["unchanged"];
  const getPercentage = (total, value) => {
    return (value * 100) / total;
  };

  return (
    <Row
      data-cy="top-keywords-overview"
      type="flex"
      justify="space-between"
      align="middle"
      style={{ marginBottom: 20 }}>
      <Col span={16}>
        <div>
          <span>
            <strong>{props.overview["increased"]}</strong> Increased
          </span>
          <Progress
            percent={getPercentage(total, props.overview["increased"])}
            showInfo={false}
            strokeColor={"rgb(52, 188, 110)"}
          />
        </div>

        <div>
          <span>
            <strong>{props.overview["dropped"]}</strong> Dropped
          </span>
          <Progress
            percent={getPercentage(total, props.overview["dropped"])}
            showInfo={false}
            strokeColor={"rgb(246, 56, 66)"}
          />
        </div>

        <div>
          <span>
            <strong>{props.overview["unchanged"]}</strong> Unchanged
          </span>
          <Progress
            percent={getPercentage(total, props.overview["unchanged"])}
            showInfo={false}
            strokeColor={"rgb(0, 0, 0)"}
          />
        </div>
      </Col>

      <Col span={7} offset={1}>
        <Card className="average-position">
          <Statistic
            title="Avg. position"
            value={props.overview["avg_pos"] && props.overview["avg_pos"]}
            precision={2}
            prefix={<Icon type="vertical-align-middle" />}
          />
        </Card>
      </Col>
    </Row>
  );
}

export default TopKeywordsOverview;
